export enum ManipulativeType {
  AlgebraTiles = 'AT',
  EquivalentFractions = 'EF',
  FractionStrips = 'FS',
  ImageSwap = 'IS',
  ImageMultiply = 'IM',
  AddingBlocks = 'AB',
  SubtractingBlocks = 'SB',
  Scorable = 'SA',
  Graph = 'GP',
  DotConnect = 'DC',
  BaseManip = 'BM'
}
